import { Injectable } from '@angular/core';
import { LanguageType } from '../enum/app.enum';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() {}

  /**
   * 언어 로컬스토리지 정보 받기
   */
  getLanguageInfo(): LanguageType | null {
    const language = localStorage.getItem('toonsquare_co_language');
    return language as LanguageType;
  }

  setLanguage(language: LanguageType): void {
    localStorage.setItem('toonsquare_co_language', language);
  }
}
